import utils from 'utils'
import collectDialogCtrl from './collectDialogCtrl'

class originalAccountCtrl {
    constructor($scope, httpRequest, $uibModal, $state, logger, sweetalert, exportSettingService, initSortService, getOvatAmtService, resultTipService,selectManualSolution) {
        //获取当前税号的进项是否是电子税局，true 电子税
        httpRequest.get_getIsElecTaxBureau().then((res) => {
            $scope.isElecTaxBureau = res.data.value
        })
        $scope.batchDropdownConfig = {
            btnText: '批量操作',
            options: [
                {
                    text: '手动查验',
                    handler() {
                        $scope.commitVerify()
                    },
                },
                {
                    text: '批量收票',
                    handler() {
                        $scope.batchRecieveInv()
                    },
                },
                {
                    text: '批量取消收票',
                    handler() {
                        $scope.batchCancelRecieveInv()
                    },
                },
            ],
        }
        // 已选择的行数据
        $scope.selectedRowsData
        // 当前机构的id
        $scope.currentOrgId = JSON.parse(localStorage.user_info).user.currentOrgId
        $scope.selectedRows = []
        // 批量操作下拉框控制
        $scope.exportCollapsed = false
        $scope.exportSetting = function () {
            exportSettingService('104', $scope.exportConfig)
        }
        $scope.exportConfig = {
            version: 5.52,
            detailInfo: [
                {
                    label: '发票代码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票号码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '开票日期',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票种类',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票状态',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '备注',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '货物或应税劳务服务名称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '规格型号',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '单位',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '数量',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '单价',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '金额',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '税率',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '税额',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '价税合计',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '销方名称',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '销方税号',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '销方地址电话',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '销方开户行及账号',
                    selected: false,
                    defaultWord: false,
                },
            ],
            mainInfo: [
                {
                    // 0
                    label: '勾选状态',
                    selected: true,
                    defaultWord: true,
                },
                {
                    // 1
                    label: '对账状态',
                    selected: true,
                    defaultWord: true,
                },
                {
                    // 2
                    label: '所属期',
                    selected: true,
                    defaultWord: true,
                },
                {
                    // 3
                    label: '发票代码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    // 4
                    label: '发票号码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    // 5
                    label: '开票日期',
                    selected: true,
                    defaultWord: true,
                },
                {
                    // 6
                    label: '销方名称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    // 7
                    label: '销方信用代码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    // 7
                    label: '销方地址电话',
                    selected: true,
                    defaultWord: true,
                },
                {
                    // 7
                    label: '销方开户行及账号',
                    selected: true,
                    defaultWord: true,
                },
                {
                    // 10
                    label: '合计金额',
                    selected: true,
                    defaultWord: true,
                },
                {
                    // 10
                    label: '合计税额',
                    selected: true,
                    defaultWord: true,
                },
                {
                    // 10
                    label: '价税合计',
                    selected: true,
                    defaultWord: true,
                },
                {
                    // 10
                    label: '发票种类',
                    selected: true,
                    defaultWord: true,
                },
                {
                    // 10
                    label: '发票状态',
                    selected: true,
                    defaultWord: true,
                },
                {
                    // 15
                    label: '备注',
                    selected: false,
                    defaultWord: false,
                },
                {
                    // 16
                    label: '收款人',
                    selected: false,
                    defaultWord: false,
                },
                {
                    // 16
                    label: '复核人',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '开票人',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '购方名称',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '购方信用代码',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '购方地址电话',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '购方开户行及账号',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '勾选日期',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '会计期间',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '凭证号',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '收票状态',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '收票人/时间',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '全票面信息',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '查验结果',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '收票状态',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '数据采集时间',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '入账月份',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '归档月份',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '账套编码',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '报销状态',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '关联单据号',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '来源系统',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '业务单据号',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '待抵扣标志',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '机构名称',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '事业部',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '所属大区',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '管理城市',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '主管税局所在省市',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '状态比对',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '付款日期',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '数电票号码',
                    selected: true,
                    defaultWord: true,
                }, {
                    label: '红字锁定标识',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '来源系统编码',
                    selected: false,
                    defaultWord: false,
                },
            ],
        }

        // 查询参数
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {
                checkStatus: '', // 认证状态 0：认证通过，1：认证未通过，255：待认证 ,
                authType: '', //  1-扫描认证 2-勾选认证
                creditCode: '', // 税号（用于权限控制） ,
                invoiceCode: '', // 发票代码 ,
                invoiceDateBegin: '', // 开票日期起始日期 ,
                invoiceDateEnd: '', // 开票日期结束日期 ,
                receiveTimeBegin: '', // 收票开始日期
                receiveTimeEnd: '', // 收票结束日期
                invoiceNumberBegin: '', // 发票号码起始号码 ,
                invoiceNumberEnd: '', // 发票号码结束号码 ,
                invoiceStatus: '', // 发票状态 ,
                invoiceType: '', // 发票种类,0(专票);2(普票);3(卷式票);51(电子票)等 ,
                isReceived: '', // 收票状态：1-收票 0-未收票 ,
                periodCode: '', // 所属期 , TODO
                saleNameCreditCode: '',
                ivatInvoiceIsExist: '',
                invoiceAccountStatus: '',
                taxPeriod: '',
                paymentMonth: '',
                archiveMonth: '',
                reimbursementStatus: '',
                statementNumber: '',
                voucherNumber: '',
                sourceSystem: '',
                claimNumber: '',
                receiveUser: '', //收票人
                sourceAppId: '', //来源系统编码
                orgIdList: $scope.orgIdListArr ? $scope.orgIdListArr : [JSON.parse(localStorage.user_info).user.currentOrgId],
            },
        }
        $scope.reset = function reset() {
            $scope.queryParam.param = {
                checkStatus: '', // 认证状态 0：认证通过，1：认证未通过，255：待认证 ,
                authType: '', //  1-扫描认证 2-勾选认证
                creditCode: '', // 税号（用于权限控制） ,
                invoiceCode: '', // 发票代码 ,
                invoiceDateBegin: '', // 开票日期起始日期 ,
                invoiceDateEnd: '', // 开票日期结束日期 ,
                receiveTimeBegin: '', // 收票开始日期
                receiveTimeEnd: '', // 收票结束日期
                invoiceNumberBegin: '', // 发票号码起始号码 ,
                invoiceNumberEnd: '', // 发票号码结束号码 ,
                invoiceStatus: '', // 发票状态 ,
                invoiceType: '', // 发票种类,0(专票);2(普票);3(卷式票);51(电子票)等 ,
                isReceived: '', // 收票状态：1-收票 0-未收票 2-已取消,
                periodCode: '', // 所属期 , TODO
                saleNameCreditCode: '',
                ivatInvoiceIsExist: '',
                invoiceAccountStatus: '',
                taxPeriod: '',
                archiveMonth: '',
                paymentMonth: '',
                reimbursementStatus: '',
                statementNumber: '',
                voucherNumber: '',
                sourceSystem: '',
                claimNumber: '',
                receiveUser: '', //收票人
                sourceAppId: '', //来源系统编码
                orgIdList: $scope.orgIdListArr,
            }
            $scope.belleRegionCityList = []
            getUserOrgList()
            $scope.$broadcast('selectedOrgList', $scope.selectedOrgList)
        }

        function confirm(msg) {
            return new Promise((resolve) => {
                sweetalert.swal(
                    {
                        title: '操作提醒',
                        text: msg,
                        // type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: '#0096e7',
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        closeOnConfirm: true,
                        closeOnCancel: true,
                    },
                    (isConfirm) => {
                        if (isConfirm) {
                            resolve()
                        }
                    }
                )
            })
        }
        const startDate = new Date()
        startDate.setFullYear(startDate.getFullYear() - 1)
        // 所属期日期控件设置 查一年
        $scope.datePickerConfig = {
            startDate,
            endDate: new Date(),
            format: 'yyyy-mm',
            startView: 'year',
            minView: 'year',
        }

        $scope.datePickerConfig1 = {
            startDate,
            endDate: new Date(),
            format: 'yyyymm',
            startView: 'year',
            minView: 'year',
        }
        // 批量操作间ID拼成id1,id2,格式
        // @param id 传了表示单个操作
        function getSelectedRow(selectedRowsArr, id) {
            let selectedRows
            if (id) {
                selectedRows = id
            } else if (selectedRowsArr.length === 0) {
                logger.logError('请先选择发票行')
                return ''
            } else {
                selectedRows = selectedRowsArr.join(',')
            }
            return selectedRows
        }
        // 批量收票如果传了item则单个收票
        $scope.batchRecieveInv = function batchRecieveInv(item) {
            const selectedRows = item ? item : $scope.selectedRows
            if (selectedRows.length == 0) {
                logger.logError('请先选择发票行')
                return
            }
            let confireMsg = ''
            const arrLen = selectedRows.length
            const notCollectedRows = selectedRows.filter((x) => x.isReceived == '0')
            const cancelCollectedRows = selectedRows.filter((x) => x.isReceived == '2')
            if (item) {
                confireMsg = '确认已收到票据？'
            } else {
                confireMsg = `当前选中票据共${arrLen}张，还未收票的票据${notCollectedRows.length}张， 已取消的票据${cancelCollectedRows.length}张`
            }
            confirm(confireMsg).then(() => {
                if (notCollectedRows.length || cancelCollectedRows.length) {
                    const invoiceAccountIdList = [...notCollectedRows.map((x) => x.invoiceAccountId), ...cancelCollectedRows.map((x) => x.invoiceAccountId)]
                    httpRequest.post_batchReceiveOriginalInvoice(invoiceAccountIdList, '收票成功').then(() => {
                        $scope.queryList()
                    })
                }
            })
        }
        $scope.batchCancelRecieveInv = function batchCancelRecieveInv(item) {
            const selectedRows = item ? item : $scope.selectedRows
            if (selectedRows.length == 0) {
                logger.logError('请先选择发票行')
                return
            }
            let confireMsg = ''
            const arrLen = selectedRows.length
            const notCollectedRows = selectedRows.filter((x) => x.isReceived == '1')

            if (notCollectedRows.length === 0) {
                logger.logError('当前选中票据无可以取消收票的票据')
                return
            }
            if (item) {
                confireMsg = '确认取消票据？'
            } else {
                confireMsg = `当前选中票据共${arrLen}张，已收票的票据${notCollectedRows.length}张`
            }
            confirm(confireMsg).then(() => {
                const invoiceAccountIdList = notCollectedRows.map((x) => x.invoiceAccountId)
                httpRequest.post_batchCalReceiveOriginalInvoice(invoiceAccountIdList, arrLen === notCollectedRows.length ? '取消收票成功！' : '部分票据取消收票成功！').then(() => {
                    $scope.queryList()
                })
            })
        }
        // 批量取消收票
        $scope.batchCancel = function batchCancel(id) {
            const selectedRows = getSelectedRow($scope.selectedRows, id)
            if (selectedRows) {
                confirm('确认您选择的发票没有收到纸质票？').then(() => {
                    httpRequest.post_batchCancelReceiveOriginalInvoice(selectedRows, '取消收票成功').then(() => {
                        $scope.queryList()
                    })
                })
            }
        }
        // 请求字典值
        function requestDictData() {
            const typecodeArrStr = '["ivat_invoice_status", "ivat_orig_inv_type","ivat_invoice_is_exist","label_auth_type","ivat_inv_receive_status","check_status","ivat_collect_check_status", "voucher_account_status","interface_invoice_status","interface_source_system","wait_deduction","department_no","ivat_comparison_status","ivat_red_lock_flag","ivat_source_app_id"]'
            httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
                $scope.dictionary = $.extend($scope.dictionary, res.data.value)
            })
        }
        // 字典值
        $scope.dictionary = {
            receive_type: [
                {
                    enumName: '未收票',
                    enumCode: '0',
                },
                {
                    enumName: '已收票',
                    enumCode: '1',
                },
            ],
            ivat_invoice_info_exist_status: [
                {
                    enumName: '未获取',
                    enumCode: '0',
                },
                {
                    enumName: '已获取',
                    enumCode: '1',
                },
            ],
        }
        //所属大区
        httpRequest.get_getBelleRegion().then((res) => {
            $scope.belleRegionList = res.data.value
        })
        // 获取主管税局省（市）
        httpRequest.get_getAllTaxBureau(localStorage.getItem('id_token')).then((res) => {
            $scope.dictDataProvince = res.data.value
        })
        // 联动查询出管理城市
        $scope.linkageQuery = function (enumName) {
            let departmenNoObj = $scope.dictionary.department_no.find((v) => {
                return v.enumName === enumName
            })
            let belleRegionListObj = $scope.belleRegionList.find((v) => {
                return v.regionName === enumName
            })
            if (departmenNoObj) {
                $scope.departmentNo = departmenNoObj.enumCode
            }
            if (belleRegionListObj) {
                $scope.regionNo = belleRegionListObj.treeLevelCode
            }
            let params = {
                affiliation: $scope.departmentNo,
                regionNo: $scope.regionNo,
            }
            if (params.affiliation == '' || params.regionNo == '') return
            httpRequest.get_getBelleRegion(params).then((res) => {
                $scope.belleRegionCityList = res.data.value
            })
        }
        //机构树的check配置信息
        $scope.config = {
            check: {
                enable: true, //显示不显示复选框
                chkboxType: { Y: '', N: '' },
                chkStyle: 'radio',
                radioType: 'all',
            },
        }
        // 获取机构
        function getUserOrgList() {
            let currentOrgId = JSON.parse(localStorage.user_info).user.currentOrgId
            httpRequest.get_getUserOrgList().then((res) => {
                if (res.data.success) {
                    $scope.orgList = res.data.value
                    // 机构勾选变化
                    $scope.orgIdListArr = []
                    // 展开节点及全选
                    angular.forEach($scope.orgList, function (item, index) {
                        item.open = false
                        // 默认勾选当前机构
                        if (item.orgId === currentOrgId) {
                            item.checked = true
                            $scope.orgIdListArr.push(item.orgId)
                            // 默认显示当前机构
                            $scope.selectedOrgList = [item]
                        }
                    })
                    $scope.queryParam.param.orgIdList = $scope.orgIdListArr
                    // 返回机构名称
                    $scope.fliterOrgName = function (id) {
                        if (id === null) {
                            return id
                        }
                        if (res.data.value === null) {
                            return id
                        }
                        const fliterUkeyNameArr = res.data.value.filter((item) => item.orgId === id)
                        if (fliterUkeyNameArr.length > 0) {
                            return fliterUkeyNameArr[0].orgName
                        }
                        return id
                    }
                }
            })
        }
        getUserOrgList()
        // 所选择的机构名称
        $scope.handleOrgChange = function (orgData) {
            //重置
            $scope.orgIdListArr.length = 0
            if (orgData.length > 0) {
                angular.forEach(orgData, function (item, index) {
                    $scope.orgIdListArr.push(item.orgId)
                    $scope.currentOrgId = item.orgId
                })
                $scope.queryParam.param.orgIdList = $scope.orgIdListArr
            } else {
                $scope.orgIdListArr = []
                $scope.queryParam.param.orgIdList = $scope.orgIdListArr
            }
        }
        // $scope.filterAuthStatus = function filterAuthStatus(rowData) {
        //     if (rowData.authStatus === '0') {
        //         if (rowData.authType === '1') {
        //             return '已扫描认证'
        //         }
        //         if (rowData.authType === '2') {
        //             return '已勾选认证'
        //         }
        //         return '已认证'
        //     }
        //     if (rowData.authStatus === '1') {
        //         return '认证未通过'
        //     }
        //     return '未认证'
        // }
        // 认证状态为认证状态和认证类型的合并字段，查询时需要拆成两个
        // function splitAuthStatus(checkStatus) {
        //     const result = {
        //         authStatus: '',
        //         authType: '2',
        //     }
        //     if (!checkStatus) {
        //         return result
        //     }
        //     result.authStatus = checkStatus
        //     return result
        // }

        $scope.totalItems = 0
        // let isSearch = false
        // $scope.$watch('queryParam', () => {
        //     isSearch = false
        // }, true)
        // $scope.$on('$stateChangeStart', (e, toState) => {
        //     if (toState.name.indexOf('input.certification.originalAccount') != -1) {
        //         isSearch && sessionStorage.setItem('originalParam', JSON.stringify($scope.queryParam))
        //     }
        // })
        $scope.currentOvatAmt = {}
        $scope.selectedRows = []
        $scope.$watch('selectedRows.length', () => {
            if (!$scope.selectedRows.length) {
                $scope.adValoremTotal = $scope.currentOvatAmt.adValoremTotal
                $scope.invoiceNum = $scope.currentOvatAmt.invoiceNum
                $scope.totalAmt = $scope.currentOvatAmt.totalAmt
                $scope.totalTaxamt = $scope.currentOvatAmt.totalTaxamt
                return
            }
            let arr = []
            $scope.selectedRows.forEach((i) => {
                $scope.collectList.forEach((item) => {
                    if (item.invoiceAccountId == i.invoiceAccountId) arr.push(item)
                })
            })
            const { adValoremTotal, totalAmt, totalTaxamt } = getOvatAmtService(arr)
            $scope.adValoremTotal = adValoremTotal
            $scope.invoiceNum = $scope.selectedRows.length
            $scope.totalAmt = totalAmt
            $scope.totalTaxamt = totalTaxamt
        })

        function getData() {
            httpRequest.post_getIvatOriginalInvoiceStatics($scope.queryParam.param).then((res) => {
                $scope.adValoremTotal = res.data.value.adValoremTotal.toFixed(2) || '0.00'
                $scope.invoiceNum = res.data.value.invoiceNum || 0
                $scope.totalAmt = res.data.value.totalAmt.toFixed(2) || '0.00'
                $scope.totalTaxamt = res.data.value.totalTaxamt.toFixed(2) || '0.00'
                $scope.currentOvatAmt = {
                    adValoremTotal: $scope.adValoremTotal,
                    invoiceNum: $scope.invoiceNum,
                    totalAmt: $scope.totalAmt,
                    totalTaxamt: $scope.totalTaxamt,
                }
            })
        }
        // 查询列表
        $scope.queryList = function queryList() {
            $scope.queryParam = sessionStorage.originalParam ? JSON.parse(sessionStorage.originalParam) : $scope.queryParam
            $scope.queryParam.param.periodCode = $scope.queryParam.param.periodCode.replace('-', '')
            const { queryParam } = $scope
            // Object.assign(queryParam.param, splitAuthStatus(queryParam.param.checkStatus))
            httpRequest.post_getOriginalInvoiceListByCollect(queryParam).then((res) => {
                $scope.collectList = res.data.value.list
                $scope.totalItems = res.data.value.total
                $scope.queryParam.pageNum = res.data.value.pageNum
                // 查询之后清空已经选择的数据
                $scope.selectedRows = []
            })
            getData()
        }
        $scope.searchList = function () {
            sessionStorage.setItem('originalParam', JSON.stringify($scope.queryParam))
            $scope.queryList()
        }
        // 分页
        $scope.pageChanged = function () {
            // 点击页码发起查询
            sessionStorage.setItem(
                'originalParam',
                JSON.stringify({
                    orderMap: $scope.queryParam.orderMap,
                    pageNum: $scope.queryParam.pageNum,
                    pageSize: $scope.queryParam.pageSize,
                    param: sessionStorage.originalParam
                        ? JSON.parse(sessionStorage.originalParam).param
                        : {
                              checkStatus: '', // 认证状态 0：认证通过，1：认证未通过，255：待认证 ,
                              authType: '', //  1-扫描认证 2-勾选认证
                              creditCode: '', // 税号（用于权限控制） ,
                              invoiceCode: '', // 发票代码 ,
                              invoiceDateBegin: '', // 开票日期起始日期 ,
                              invoiceDateEnd: '', // 开票日期结束日期 ,
                              receiveTimeBegin: '', // 收票开始日期
                              receiveTimeEnd: '', // 收票结束日期
                              invoiceNumberBegin: '', // 发票号码起始号码 ,
                              invoiceNumberEnd: '', // 发票号码结束号码 ,
                              invoiceStatus: '', // 发票状态 ,
                              invoiceType: '', // 发票种类,0(专票);2(普票);3(卷式票);51(电子票)等 ,
                              isReceived: '', // 收票状态：1-收票 0-未收票 ,
                              periodCode: '', // 所属期 , TODO
                              saleNameCreditCode: '',
                              ivatInvoiceIsExist: '',
                              invoiceAccountStatus: '',
                              taxPeriod: '',
                              paymentMonth: '',
                              archiveMonth: '',
                              sourceAppId: '', //来源系统编码
                              orgIdList: $scope.orgIdListArr,
                          },
                })
            )
            $scope.queryList()
        }
        // $scope.reset()
        // 自定义查询字段配置
        $scope.customizedConfig = {
            version: 1.28,
            queryConfig: [
                {
                    label: '开票日期',
                    default: true,
                    selected: true,
                },
                {
                    label: '发票号码',
                    default: true,
                    selected: true,
                },
                {
                    label: '发票状态',
                    default: true,
                    selected: true,
                },
                {
                    label: '勾选状态',
                    default: true,
                    selected: true,
                },
                {
                    label: '发票代码',
                    default: false,
                    selected: false,
                },
                {
                    label: '销方名称/信用代码',
                    default: false,
                    selected: false,
                },
                {
                    label: '收票状态',
                    default: false,
                    selected: false,
                },
                {
                    label: '所属期',
                    default: false,
                    selected: false,
                },
                {
                    label: '发票种类',
                    default: false,
                    selected: false,
                },
                {
                    label: '全票面信息',
                    default: false,
                    selected: false,
                },
                {
                    label: '收票时间',
                    default: false,
                    selected: false,
                },
                {
                    label: '对账状态',
                    default: false,
                    selected: false,
                },
                {
                    label: '会计期间',
                    default: false,
                    selected: false,
                },
                {
                    label: '入账月份',
                    default: false,
                    selected: false,
                },
                {
                    label: '归档月份',
                    default: false,
                    selected: false,
                },
                {
                    label: '报销状态',
                    default: false,
                    selected: false,
                },
                {
                    label: '关联单据号',
                    default: false,
                    selected: false,
                },
                {
                    label: '凭证号',
                    default: false,
                    selected: false,
                },
                {
                    label: '来源系统',
                    default: false,
                    selected: false,
                },
                {
                    label: '业务单据号',
                    default: false,
                    selected: false,
                },
                {
                    label: '待抵扣标志',
                    default: false,
                    selected: false,
                },
                {
                    label: '收票人',
                    default: false,
                    selected: false,
                },
                {
                    label: '机构名称',
                    default: false,
                    selected: false,
                },
                {
                    label: '事业部',
                    selected: false,
                    default: false,
                },
                {
                    label: '所属大区',
                    selected: false,
                    default: false,
                },
                {
                    label: '管理城市',
                    selected: false,
                    default: false,
                },
                {
                    label: '主管税局所在省市',
                    selected: false,
                    default: false,
                },
                {
                    label: '状态比对',
                    selected: false,
                    default: false,
                },
                {
                    label: '付款日期',
                    selected: false,
                    default: false,
                },
                {
                    label: '数电票号码',
                    selected: false,
                    default: false,
                },
                {
                    label: '红字锁定标识',
                    selected: false,
                    default: false,
                },
                {
                    label: '来源系统编码',
                    selected: false,
                    default: false,
                },
            ],
            table: [
                {
                    label: '勾选状态',
                    selected: true,
                    default: true,
                },
                {
                    label: '对账状态',
                    selected: true,
                    default: true,
                },
                {
                    label: '所属期',
                    selected: true,
                    default: true,
                },
                {
                    label: '开票日期',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票代码',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票号码',
                    selected: true,
                    default: true,
                },
                {
                    label: '销方名称',
                    selected: true,
                    default: true,
                },
                {
                    label: '合计金额',
                    selected: true,
                    default: true,
                },
                {
                    label: '合计税额',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票状态',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票种类',
                    selected: true,
                    default: true,
                },
                {
                    label: '收票状态',
                    selected: true,
                    default: true,
                },
                {
                    label: '信用代码',
                    selected: false,
                    default: false,
                },
                {
                    label: '勾选日期',
                    selected: false,
                    default: false,
                },
                {
                    label: '会计期间',
                    selected: false,
                    default: false,
                },
                {
                    label: '凭证号',
                    selected: false,
                    default: false,
                },
                {
                    label: '数据采集时间',
                    selected: false,
                    default: false,
                },
                {
                    label: '全票面信息',
                    selected: false,
                    default: false,
                },
                {
                    label: '查验结果',
                    selected: false,
                    default: false,
                },
                {
                    label: '收票人/时间',
                    default: false,
                    selected: false,
                },
                {
                    label: '入账月份',
                    default: false,
                    selected: false,
                },
                {
                    label: '归档月份',
                    default: false,
                    selected: false,
                },
                {
                    label: '报销状态',
                    default: false,
                    selected: false,
                },
                {
                    label: '关联单据号',
                    default: false,
                    selected: false,
                },
                {
                    label: '来源系统',
                    default: false,
                    selected: false,
                },
                {
                    label: '业务单据号',
                    default: false,
                    selected: false,
                },
                {
                    label: '待抵扣标志',
                    default: false,
                    selected: false,
                },
                {
                    label: '机构名称',
                    default: false,
                    selected: false,
                },
                {
                    label: '事业部',
                    selected: false,
                    default: false,
                },
                {
                    label: '所属大区',
                    selected: false,
                    default: false,
                },
                {
                    label: '管理城市',
                    selected: false,
                    default: false,
                },
                {
                    label: '主管税局所在省市',
                    selected: false,
                    default: false,
                },
                {
                    label: '账套编码',
                    selected: false,
                    default: false,
                },
                {
                    label: '状态比对',
                    selected: false,
                    default: false,
                },
                {
                    label: '付款日期',
                    selected: false,
                    default: false,
                },
                {
                    label: '数电票号码',
                    selected: false,
                    default: false,
                },
                {
                    label: '红字锁定标识',
                    selected: false,
                    default: false,
                },
                {
                    label: '来源系统编码',
                    selected: false,
                    default: false,
                },
            ],
        }

        // 表头排序
        $scope.orderMap = initSortService('originalParam')
        $scope.selectedHandle = function selectedHandle() {
            $scope.queryParam.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.queryParam.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            sessionStorage.setItem('originalParam', JSON.stringify($scope.queryParam))
            $scope.queryList()
        }

        // 表格下拉框配置
        $scope.tableDropdownConfig = [
            {
                label: '详情',
                handler(item) {
                    const url = $state.href(
                        'input.certification.originalAccount.detail',
                        {
                            object: JSON.stringify({
                                invoiceCode: item.invoiceCode ? item.invoiceCode : '',
                                invoiceNumber: item.invoiceNumber,
                            }),
                        },
                        {
                            reload: true,
                        }
                    )
                    window.open(url, '_blank')
                },
                showWhile() {
                    return true
                },
            },
            {
                label: '查验',
                handler(item) {
                    // 判断开票日期是否超过一年
                    // const nowDate = new Date()
                    // const cutOffTime = new Date(nowDate.getFullYear() - 1, nowDate.getMonth(), nowDate.getDate() + 1) // 去年今日及之前都不能查验
                    // if (item.invoiceDate) {
                    //     let invDate = new Date(item.invoiceDate.slice(0, 10))
                    //     if (invDate < cutOffTime) {
                    //         logger.logError('超过一年的发票不可再次查验！')
                    //         return false
                    //     }
                    // }
                    // 判断是否获取全票面信息
                    if (item.ivatInvoiceIsExist === '1') {
                        logger.logError('已经获取该发票的全票面信息，请勿重复请求！')
                        return false
                    }
                    httpRequest.post_batchCommitVer([item.invoiceAccountId]).then((res) => {
                        if (res.data.value.length) {
                            let str = ''
                            res.data.value.forEach((o) => {
                                str += `单据${o.infoId}${o.errorMsg}`
                            })
                            logger.logError(str)
                        }
                        $scope.queryList()
                    })
                },
                showWhile() {
                    return true
                },
            },
            {
                label: '收票',
                handler(item) {
                    $scope.batchRecieveInv([item])
                },
                showWhile(item, hasPermit) {
                    return item.isReceived == '0' || item.isReceived == '2' //hasPermit('receive_invoice')
                },
            },
            {
                label: '取消收票',
                handler(item) {
                    $scope.batchCancelRecieveInv([item])
                },
                showWhile(item, hasPermit) {
                    return item.isReceived == '1'
                },
            },
        ]

        // 初始化ctrl
        function init() {
            $scope.collectList = []
            requestDictData()
            $scope.queryList()
        }
        init()

        $scope.exportExcel = function exportExcel() {
            const exportParam = $.extend({}, $scope.queryParam.param, {
                invoiceAccountIds: $scope.selectedRows.map((x) => x.invoiceAccountId).join(','),
            })
            const _url = `${host.etcloudIvatApp}auth/originalInvoice/exportToExcel?accessToken=${localStorage.getItem('id_token')}`
            // httpRequest.get_exportOriginAccout(exportParam)
            for (let i in $scope.queryParam.orderMap) {
                exportParam.sortField = i + ':' + $scope.queryParam.orderMap[i]
            }
            utils.post_downLoad(exportParam, _url)
        }

        /**
         *  打开手动收集弹窗
         */
        function showCollectionDialog() {
            return $uibModal.open({
                templateUrl: 'origin-account-collect-dialog.html',
                controller: collectDialogCtrl,
                backdrop: 'static',
                openedClass: 'mod-modal mod-modal-md',
                resolve: {
                    items1() {
                        return $scope.dictionary.ivat_collect_check_status
                    },
                    orgId() {
                        return $scope.currentOrgId
                    },
                    orgList() {
                        return $scope.orgList
                    },
                },
            }).result
        }

        // let reConmmit = 0
        let importinglayer
        // 采集完成
        function done() {
            window.layer.close(importinglayer)
            $scope.queryList()
        }

        function collectFromLocal(param, reSubmitCount) {
            let providerEncode = param.provider.replace(/\s/g, '+')
            let queryParam = {
                SID: param.sid,
                SIDParam: param.msg.replace(new RegExp('[+]', 'gm'), '_'),
                Provider: providerEncode,
            }
            if (!param.provider) {
                delete queryParam.Provider
            }
            $.jsonp({
                url: `${param.serverAddress}/InvDk`,
                data: queryParam,
                timeout: 86400000,
                charset: 'GBK',
                callbackParameter: 'callback',
                success(json) {
                    if (json.retcode === '1') {
                        param.data = json.ResponseStr
                        const saveParam = $.extend({}, $scope.collectParam, {
                            data: json.ResponseStr,
                            batchNo: param.batchNo,
                            reqAuthStatus: param.reqAuthStatus,
                            reqBeginTime: param.reqBeginDate,
                            reqEndTime: param.reqEndDate,
                        })
                        saveFromLocal(saveParam, reSubmitCount)
                    } else {
                        logger.logError(json.retmsg)
                        done()
                    }
                },
                error() {
                    logger.logError('进项服务连接失败')
                    done()
                },
            })
        }
        //随机ID
        function randomID(length) {
            return Number(Math.random().toString().substr(3, length) + Date.now()).toString(36)
        }
        // 从服务器采集
        function collectFromRemote(param) {
            if ($scope.collectParam.checkFlag == 3) {
                $scope.collectParam.checkType = '1'
            }
            httpRequest
                .post_saveIvatCollectBatchByRemote(
                    $.extend($scope.collectParam, {
                        sid: param.sid,
                        msg: param.msg,
                        batchNo: param.batchNo ? param.batchNo : randomID(32),
                        curPage: param.curPage,
                        reqAuthStatus: param.reqAuthStatus ? param.reqAuthStatus : $scope.collectParam.reqAuthStatus,
                        reqBeginTime: param.reqBeginDate,
                        reqEndTime: param.reqEndDate,
                        collType: param.collType,
                    })
                )
                .then((res) => {
                    if ($scope.collectParam.isGLPT) {
                        queryIvatCollectBatchResult(res.data.value)
                    } else {
                        done()
                    }
                })
        }
        // 查询进项发票电子底账采集结果查询
        function queryIvatCollectBatchResult(param) {
            httpRequest.post_queryIvatCollectBatchResult(param).then((res) => {
                if (res.data.value.sendStatus == '1' && res.data.value.hasNext) {
                    collectFromRemote(res.data.value)
                } else if (res.data.value.sendStatus == '0') {
                    setTimeout(function () {
                        queryIvatCollectBatchResult(param)
                    }, 2000)
                } else if (res.data.value.sendStatus == '2') {
                    logger.logError('采集失败')
                    done()
                } else {
                    done()
                }
            })
        }
        // 获取采集参数
        function queryCollectParam() {
            // 进项设备类型
            const inputDeviceType = (localStorage.inputDeviceType && JSON.parse(localStorage.getItem('inputDeviceType'))) || {}
            $scope.collectParam.deviceType = inputDeviceType.deviceType
            if ($scope.collectParam.checkFlag == 3) {
                $scope.collectParam.checkType = '1'
            }
            httpRequest.post_getCollectParam($scope.collectParam).then((res) => {
                if (!res.data.success) {
                    return done()
                }
                // reConmmit = 0
                // 返回参数数组（因为有时需调用两个接口）
                res.data.value.forEach((item) => {
                    if (item.serverType === 'local') {
                        collectFromLocal(item, 0)
                    } else {
                        collectFromRemote(item)
                    }
                })
            }, done)
        }
        // 开始采集获取batchNo
        function startCollect() {
            importinglayer = window.layer.msg('正在采集, 请耐心等待', {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
            })
            // httpRequest.get_getBeanId().then((res) => {
            //     $scope.collectParam.batchNo = res.data.value
            //     queryCollectParam($scope.collectParam)
            // })
            queryCollectParam($scope.collectParam)
        }

        // 页面点击采集
        $scope.collect = async function collect() {
             let flag =  await selectManualSolution.getResult()
            if(!flag) return
            showCollectionDialog().then((collectParam) => {
                if (collectParam.isGLPT) {
                    if (collectParam.reqAuthStatus == '0') {
                        collectParam.checkFlag = '4'
                        collectParam.reqAuthStatus = '0'
                    }
                    if (collectParam.reqAuthStatus == '1') {
                        collectParam.checkFlag = '1'
                        collectParam.reqAuthStatus = '1'
                    }
                    if (collectParam.reqAuthStatus == '2') {
                        collectParam.checkFlag = '2'
                        collectParam.reqAuthStatus = '1'
                    }
                } else {
                    if (collectParam.checkFlag === '3') {
                        collectParam.checkFlag = '1'
                        collectParam.checkType = '1'
                    }
                    if (collectParam.checkFlag === '2' || collectParam.checkFlag === '3') {
                        return logger.logSuccess('采集成功')
                    }
                }
                // if (collectParam.checkFlag === '3') {
                //     collectParam.checkFlag = '1'
                //     collectParam.checkType = '1'
                // }
                $scope.collectParam = collectParam
                startCollect()
            })
        }

        function saveFromLocal(param, reSubmitCount) {
            if ($scope.collectParam.checkFlag == 3) {
                param.checkType = '1'
            }
            httpRequest.post_saveIvatCollectBatch(param).then((res) => {
                const result = res.data.value
                if (res.data.success) {
                    if (result.resultCount < $scope.collectParam.displayLength) {
                        done()
                    } else {
                        $scope.collectParam.displayStart += $scope.collectParam.displayLength
                        queryCollectParam(param)
                    }
                } else if (reSubmitCount <= 3) {
                    // 失败 重新提交 TODO 3次
                    reSubmitCount += 1
                    saveFromLocal(param, reSubmitCount)
                } else {
                    done()
                    logger.logError('保存失败')
                }
            })
        }

        $scope.checkItem = () => {
            console.log('checked')
        }

        // 手动查验
        $scope.commitVerify = function commitVerify() {
            if (!$scope.selectedRows || $scope.selectedRows.length === 0) {
                logger.logError('请先选择发票行')
                return
            }
            // const nowDate = new Date()
            // const cutOffTime = new Date(nowDate.getFullYear() - 1, nowDate.getMonth(), nowDate.getDate() + 1) // 去年今日及之前都不能查验
            let verFlag = $scope.selectedRows.every((temp) => {
                for (let item of $scope.collectList) {
                    if (item.invoiceAccountId !== temp.invoiceAccountId) continue
                    // 判断开票日期是否超过一年
                    // if (item.invoiceDate) {
                    //     let invDate = new Date(item.invoiceDate.slice(0, 10))
                    //     if (invDate < cutOffTime) {
                    //         logger.logError('您选择的发票中包含开票日期超过一年的发票，不可再次查验，请重新选择！')
                    //         return false
                    //     }
                    // }
                    // 判断是否获取全票面信息
                    if (item.ivatInvoiceIsExist === '1') {
                        logger.logError('您选择的发票中包含已经获取全票面信息的发票，请重新选择，勿重复请求！')
                        return false
                    }
                }
                return true
            })
            if (!verFlag) return
            sweetalert
                .confirm(
                    '查验提示',
                    `本次共选择${$scope.selectedRows.length}条数据进行手动查验，确定后系统会排队获取结果，请过几分钟后再进入界面查看！<br>
                1、可查验最近五年内增值税发票管理系统开具的发票； <br>
                2、每张发票每日查验不超5次； <br>
                3、当天开具的发票最快第二天可查，如没有则请过后几天再试！
            `
                )
                .then(() => {
                    utils.loading('正在查验')
                    let oterSelectedRow = $scope.selectedRows.map((x) => x.invoiceAccountId)
                    httpRequest.post_batchCommitVer(oterSelectedRow).then((res) => {
                        utils.loaded()
                        if (res.data.value.length) {
                            const params = {
                                sourceCount: $scope.selectedRows.length,
                                errorCount: res.data.value.length,
                                list: res.data.value,
                                title: '查验',
                            }
                            resultTipService.openErrorModal(params, $scope.queryList)
                        } else {
                            logger.logSuccess(`查验成功${$scope.selectedRows.length}张票据`)
                            $scope.queryList()
                        }
                    })
                })
        }
    }
}

originalAccountCtrl.$inject = ['$scope', 'httpRequest', '$uibModal', '$state', 'logger', 'sweetalert', 'exportSettingService', 'initSortService', 'getOvatAmtService', 'resultTipService','selectManualSolution']
export default originalAccountCtrl



// WEBPACK FOOTER //
// ./src/app/input/specialInvoiceCertification/originalAccount/originalAccountListCtrl.js